import { Box, Logo, PancakeStack, Separator } from '@betterment/samba-react';

import PartialErrorFallback from './PartialErrorFallback';

const FullPageErrorFallback = () => {
  return (
    <PancakeStack css={{ maxWidth: 'screen', height: '100vh' }}>
      <PancakeStack.Header
        css={{
          px: 'space.600',
          py: 'space.200',
          maxWidth: 'screen',
        }}
      >
        <Logo type="signature" css={{ height: 'size.300' }} />
      </PancakeStack.Header>

      <PancakeStack.Main css={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Separator />
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
          }}
        >
          <PartialErrorFallback />
        </Box>
      </PancakeStack.Main>
    </PancakeStack>
  );
};

export default FullPageErrorFallback;
